import { useMutation } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'utils/hooks/useToast/useToast';
import { SignUpPartialConfirm } from 'graphqlDocuments/mutations';

const CompleteProfileContainer = (CompleteProfile) => {
  return function CompleteProfileContainerWrapper(props) {
    const { t } = useTranslation(['ERRORS', 'STATIC', 'SIGNUP']);
    const { toast } = useToast();

    const [signUpPartialConfirmMutation] = useMutation(SignUpPartialConfirm);

    const signUpPartialConfirm = (variables) => signUpPartialConfirmMutation({ variables });

    return (
      <CompleteProfile {...props} t={t} toast={toast} signUpPartialConfirm={signUpPartialConfirm} />
    );
  };
};

export default CompleteProfileContainer;
